import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetCampaignsApi } from './use-get-campaigns-api';

const endpoint = 'ums/v1/advertising/managing/banners';
export const updateActivationCampaignEndpointIdentifier = endpoint;

type TData = Record<string, any>;
type TError = AxiosError;

type TVariables = {
  campaignId: number;
  isActive: string;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useUpdateActivationCampaignApi(options?: Options): ReturnType {
  const { refetch: refetchCampaigns } = useGetCampaignsApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ campaignId, isActive }: TVariables) => {
    try {
      const { data } = await http.patch(endpoint + `/${campaignId}/${isActive}`);

      refetchCampaigns();

      toast({
        description: 'Campaign has been updated successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
